import { useBusinessProfileStepsContext } from 'pages/settings/pages/compliance/pages/businessProfile/context/businessProfileStepsContext'
import { usePathSegment } from './usePathSegment'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useBusinessProfileStepsContext()

  return getProgressInfoTitle(usePathSegment())
}
